import { createRouter, createWebHistory } from 'vue-router'

const routes = 
[
  { path: '/', name: 'home', component: () => import('../views/Home.vue'), 
      meta: { title: 'Virgin Money Home Loans',
              desc: 'Virgin Money home loans first established in Australian in 2003.  Speak to your mortgage broker about a Virgin home loan' }}, 
  

  //Catchall 404
  {
    path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/views/NotFound.vue'),
            meta: { title: 'Virgin Money Home Loans - 404', 
					desc: 'We can`t find this page?' }}
]

  const router = createRouter(
    {
      history: createWebHistory(process.env.BASE_URL),
      routes,
      scrollBehavior() 
        { window.scroll({top:0,left:0,behavior:'smooth'}) }
    })


  //Add Meta Tags and Canonical
  router.beforeEach((to, from) => 
  { 
    document.title = to.meta.title ?? 'Virgin Money Home Loans'
    const metaDescription = document.querySelector('meta[name="description"]');
    const metaCanonical = document.querySelector('link[rel="canonical"]');
    if(metaDescription) 
    {
      metaDescription.setAttribute('content', to.meta.desc);
      metaCanonical.setAttribute('href', 'https://virginhomeloans.com.au'+to.path);
    }
    else 
    {
      //Canonical 
      const canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', 'https://virginhomeloans.com.au'+to.path);
      document.head.appendChild(canonical);

      //Desc
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'description');
      newMeta.setAttribute('content', to.meta.desc);
      document.head.appendChild(newMeta);
    }
  })

export default router 